export default {
  SET_DATA_SEARCH (state, data) {
    state.dataSearch = data
  },
  CLEAR_DATA (state, data) {
    state.dataSearch = {
      size: 50,
      page: 1,
      userId: JSON.parse(localStorage.getItem('userData')).agentId
    }
  },
  SET_DATA_SEARCH_OTHER (state, data) {
    state.dataSearchOther = data.data
    state.router = data.router
  },
  CLEAR_DATA_OTHER (state, data) {
    state.dataSearchOther = {}
  }
}
